import React from 'react';
import { SpotSuperShort } from 'domain/Spot';
import { alpha, Box } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import { MapIconContainer } from '../MapIconContainer';
import { useShadowStyle } from '../../hooks/useShadowStyle';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface MarkerProps {
    spot: SpotSuperShort;
    color?: string;
}

const MarkerPoint = ({ spot, color }: MarkerProps) => {
    const theme = useTheme();
    const shadowStyle = useShadowStyle();
    const markerColor = color || theme.palette.secondary.contrastText;

    return (
        <Box
            sx={{
                'position': 'relative',
                '&:hover > .hover-content': {
                    display: 'block',
                },
            }}
        >
            <MapIconContainer>
                <RoomIcon
                    sx={{
                        ...shadowStyle,
                        fill: markerColor
                    }}
                    fontSize="large"
                />
            </MapIconContainer>
            <Box
                className="hover-content"
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'none',
                }}
            >
                <Box
                    sx={{
                        minWidth: '160px',
                        maxWidth: '240px',
                        py: 0.5,
                        px: 2,
                        backgroundColor: alpha(theme.palette.secondary.main, 0.7),
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: theme.defaultShadow(),
                        color: theme.palette.secondary.contrastText,
                        textShadow: theme.defaultShadow(),
                    }}
                >
                    <Typography variant="body1">{spot?.name}</Typography>
                    <Typography variant="body1">{spot?.description}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default MarkerPoint;
